import type { IAppConfigResponse } from '@modules/config/types';
import type { IContextMutationResult } from '@modules/core/services/query/types';
import { CONFIG_QUERY_KEY } from '@modules/config/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import type { IWelcomePageRedirectsPayload } from '../types';
import {
  WELCOME_PAGE_REDIRECTS_LIST_QUERY_KEY,
  WELCOME_PAGE_REDIRECTS_PERMISSIONS,
  WELCOME_PAGE_REDIRECTS_SAVE_API_URL,
  WELCOME_PAGE_REDIRECTS_SAVE_MUTATION_KEY,
} from '../constants';

export default function useSaveWelcomePageRedirectsMutation(): IContextMutationResult<void, Error, IWelcomePageRedirectsPayload> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, IWelcomePageRedirectsPayload>({
    mutationKey: [WELCOME_PAGE_REDIRECTS_SAVE_MUTATION_KEY],
    mutationFn: (payload) => fetchPost<void>(
      WELCOME_PAGE_REDIRECTS_SAVE_API_URL,
      payload,
      {
        permission: WELCOME_PAGE_REDIRECTS_PERMISSIONS.EDIT,
      },
    ),
    async onSuccess({ queryClient, variables }) {
      await queryClient.invalidateQueries({ queryKey: [WELCOME_PAGE_REDIRECTS_LIST_QUERY_KEY] });

      queryClient.setQueryData<IAppConfigResponse>([CONFIG_QUERY_KEY], (queryData) => {
        if (variables?.welcome_page_redirects && queryData) {
          return {
            ...queryData,
            welcome_page_redirects: {
              ...variables?.welcome_page_redirects,
            },
          };
        }
        return queryData;
      });
      displayPresetToast('edited');
    },
  });
}
